module.exports = __webpack_public_path__ + "static/media/35.cfb17c6a.JPG";